<template>
  <div class="notwarp">
    <el-empty v-if="notLits == null" description="数据加载中......"></el-empty>
    <el-empty v-else-if="notLits.length == 0" description="数据为空"></el-empty>
    <div v-else>
      <div class="list">
        <div class="item" v-for="(item, index) in notLits" :key="index">
          <div class="noticelist" @click="dealnotice(item)">
            <div class="not_center">
              <!-- 封面 -->
              <div class="not_cover">
                <el-image class="elimg" :src="item.noticePic" fit="fill">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline" style="font-size: 40px"></i>
                  </div>
                </el-image>
              </div>
              <div class="notcenters">
                <div class="nottit_times">
                  <!-- 标题 -->
                  <p class="not_top">{{ item.noticeTitle }}</p>
                  <!-- 时间 -->
                  <div class="time_not">
                    <div
                      class="time"
                      v-if="item.updateTime == null || item.updateTime == ''"
                    >
                      {{ item.createTime }}
                    </div>
                    <span v-else class="time_left">{{ item.createTime }}</span>
                    <span class="time_right"></span>
                  </div>
                </div>
                <!-- 内容 -->
                <div class="item_centers">
                  <p v-html="item.noticeContent.replace(/src/g, ' ')"></p>
                  <!-- <p
                    v-if="item.noticeContent.length > 40"
                    v-html="
                      item.noticeContent.replace(/src/g, ' ').slice(0, 40) + '······'
                    "
                  ></p>
                  <p v-else v-html="item.noticeContent.replace(/src/g, ' ')"></p> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "noticelist",
  props: {
    notLits: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  methods: {
    dealnotice(item) {
      this.$emit("setNotice", item);
    },
  },
};
</script>
<style lang="scss" scoped>
.notwarp {
  width: 100%;
  .item {
    width: 100%;
    margin: 20px 0;
    background: #ffffff;
    border: 1px solid #eeeeee;
    &:hover {
      box-shadow: 0px 0px 8px 0px rgba(155, 155, 155, 0.21);
    }
  }
  .noticelist {
    height: 120px;
    background: #ffffff;
    cursor: pointer;
    overflow: hidden;
    .not_center {
      overflow: hidden;
      // 封面
      .not_cover {
        width: 163px;
        height: 96px;
        text-align: center;
        margin: 12px;
        float: left;
        .elimg {
          width: 100%;
          height: 100%;
          vertical-align: middle;
        }
      }
      .notcenters {
        width: 950px;
        padding: 0 7px;
        float: left;
        .nottit_times {
          margin-top: 16px;
          overflow: hidden;
          // 标题
          .not_top {
            width: 750px;

            font-size: 20px;
            font-weight: bold;
            line-height: 1.5;
            color: #555555;
            word-break: break-all;
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            float: left;
          }
          // 时间
          .time_not {
            margin: 5px 0;
            overflow: hidden;
            font-size: 14px;
            color: #999999;
            font-weight: 400;
            float: right;
            .time_left {
              float: left;
            }
            .time_right {
              float: right;
            }
          }
        }
      }

      // 内容
      .item_centers {
        color: #666666;
        text-indent: 15px;
        line-height: 1.5;
        letter-spacing: 1px;
        margin-top: 10px;
        p {
          word-break: break-all;
          text-overflow: ellipsis;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          font-size: 14px;
        }
      }
    }
  }
}
</style>
